import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/lib/auth";
import AuthShell from "@/components/AuthShell";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ExperiencesIndex from "@/pages/ExperiencesIndex";
import ExperienceDetail from "@/pages/ExperienceDetail";
import CountryPage from "@/pages/CountryPage";
import TheCollection from "@/pages/TheCollection";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function AdminGate({ children }) {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <NotFound />;
  return children;
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <div className="App" data-testid="app-root">
          <BrowserRouter>
            <ScrollToTop />
            <AuthShell>
              <Routes>
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/spain" element={<CountryPage code="spain" />} />
                  <Route path="/italy" element={<CountryPage code="italy" />} />
                  <Route path="/portugal" element={<CountryPage code="portugal" />} />
                  <Route path="/experiences" element={<ExperiencesIndex />} />
                  <Route path="/experiences/:slug" element={<ExperienceDetail />} />
                  <Route path="/the-collection" element={<TheCollection />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/admin" element={<AdminGate><Admin /></AdminGate>} />
                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </AuthShell>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </LangProvider>
  );
}
